import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import * as _ from 'underscore';
import {
    NotificationService
} from '../../../../../app.common/modules/common/services/notification.service';
import { ICampaignInformationCardLink } from '../../../campaigns/models';
import { IInformationCardsSearch } from '../../../model/IInformationCardsSearch';
import {
    InformationCardsService
} from '../../informationCards.service';
import { ISearchInformationCardItem } from './../../../campaigns/models/index';

class InfoTagSearchController implements ng.IController {
    public static $inject = ['$scope', 'informationCardsService', 'notificationService'];

    public searchTerm: string;
    public pagination = {
        data: [] as ISearchInformationCardItem[],
        page: 1,
        pageSize: 10,
        total: 0
    };
    public waiting = false;

    public resolve: {
        items: ICampaignInformationCardLink[]
    };

    private selectedProducts: {
        [id: number]: ISearchInformationCardItem;
    } = {};

    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    constructor(
        $scope: angular.IScope,
        private informationCardsService: InformationCardsService,
        private notification: NotificationService
    ) {}

    public $onInit() {
        if (this.resolve.items && this.resolve.items.length > 0) {
            this.resolve.items.map((item) => (
                {
                    ID: item.InformationCardID,
                    Title: item.Title,
                    ImageID: item.ImageID
                } as ISearchInformationCardItem
            )).forEach((item) => this.selectProduct(item));
        }
        this.loadData();
    }

    public getImageUrl = (imageID: string) => {
        if (!imageID) {
            return null;
        }
        return this.informationCardsService.getImageUrl(imageID, 60);
    }

    public confirm() {
        this.modalInstance.close({
            $value: this.getSelectedProducts()
        });
    }

    public getSelectedCount(): number {
        return this.getSelectedProducts().length;
    }

    public selectProduct(product: ISearchInformationCardItem) {
        if (!this.selectedProducts[product.ID]) {
            this.selectedProducts[product.ID] = product;
            return;
        }

        this.selectedProducts[product.ID] = null;
    }

    public resetSearch() {
        this.searchTerm = '';
        this.search(this.searchTerm);
    }

    private search(text: string) {
        this.searchTerm = text;
        this.loadData();
    }

    private async loadData() {
        this.notification.showWaitingMessage();
        this.waiting = true;

        const filter: IInformationCardsSearch = {
            searchTerm: this.searchTerm,
            limit: this.pagination.pageSize,
            offset: (this.pagination.page - 1) * this.pagination.pageSize,
            sortColumn: 'Title',
            sortOrder: 0
        };
        const result = await this.informationCardsService.searchInformationCards(filter);
        this.pagination.data = result.Items;
        this.pagination.total = result.Total;

        this.notification.clearAll();
        this.waiting = false;
    }

    private getSelectedProducts() {
        return _.filter(this.selectedProducts, (v: any) => v || false);
    }
}

angular.module('naut').component('infoCardSearch', {
    template: require('./informationCard.search.component.html'),
    controller: InfoTagSearchController,
    controllerAs: '$ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/informationCards/components/informationCardSearch/informationCard.search.components.ts